var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header';
import '../../components/leftMenu';
import './information.css';
import "../../components/paging";
import * as authorization from "../../lib/authorization";
import * as ajax from '../../app-lib/ajax_proxy';
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/project/pools', root) || this;
        _this.fenpei = ko.observable('');
        _this.guanbi = ko.observable('');
        _this.qiangdan = ko.observable('');
        // ////
        _this.projects = ko.observableArray([]); // 信息池中所有的项目
        _this.options = ko.observableArray([{ id: 0, text: '全部' }, { id: 1, text: '微信公众号' }, { id: 2, text: 'PC端' }, { id: 3, text: '移动端' }]); // 下拉列表
        _this.cooperation = ko.observableArray([]);
        _this.projectsource = ko.observable('全部'); //项目的来源
        _this.cooperationmode = ko.observable('合作方式'); // 合作方式
        _this.rowData = ko.observable(); // 行对象
        _this.projectId = ko.observable(''); // 项目id
        _this.departmentService = ko.observable(); // 部门员工 绑定到 html
        _this.searchStaffName = ko.observable(''); // 模糊查询员工
        _this.userId = ko.observableArray([]); // 当前用户
        /////////
        _this.daili = ko.observable();
        ////
        _this.localnext = ko.observable();
        _this.local = ko.observableArray([]);
        _this.localsomeid = ko.observable();
        _this.localid = ko.observable();
        ////// 
        _this.changename = ko.observable(); //关注人搜索
        _this.postName = ko.observableArray([]); //关注人加载
        _this.choose_index = ko.observableArray(); //关注人id
        _this.username = ko.observableArray();
        //////
        _this.isAdmin = ko.observable('');
        _this.popur = ko.observable(0);
        _this.XiangXi = ko.observable(0);
        _this.projectsource.subscribe(function () {
            _this.data.projectSource = _this.projectsource();
            _this.data.cooperationMode = _this.cooperationmode();
            if (_this.localid() == undefined) {
                _this.localid("");
            }
            else {
                _this.data.province = _this.localid().name;
            }
            if (_this.localsomeid() == undefined) {
                _this.localsomeid("");
            }
            else {
                _this.data.city = _this.localsomeid().name;
            }
            _this.data.pageIndex = 1;
            _this.loadData();
        });
        _this.cooperationmode.subscribe(function () {
            _this.data.projectSource = _this.projectsource();
            _this.data.cooperationMode = _this.cooperationmode();
            if (_this.localid() == undefined) {
                _this.localid("");
            }
            else {
                _this.data.province = _this.localid().name;
            }
            if (_this.localsomeid() == undefined) {
                _this.localsomeid("");
            }
            else {
                _this.data.city = _this.localsomeid().name;
            }
            _this.data.pageIndex = 1;
            _this.loadData();
        });
        return _this;
    }
    HeaderModel.prototype.open = function () {
    };
    HeaderModel.prototype.Popur = function (root, data, parent) {
        // console.log("ddddddd"+this.viewModel().data.pageIndex);
        var pageIndex = this.viewModel().data.pageIndex;
        this.daili(this.viewModel());
        if (this.popur() == 1) {
            this.popur(0);
        }
        else {
            this.popur(1);
        }
        this.postName([]);
        this.changename('');
        this.rowData(data); // 点击分配 把行数据保存起来
        this.projectId(data.id); //点击分配 把项目id保存起来
        this.choose_index([]);
        ////////////////////////////////////;	
        this.data = {};
        this.data.pageIndex = 1;
        //this.url = "/api/project/pools";
        this.data.projectSource = this.projectsource();
        this.data.cooperationMode = this.cooperationmode();
        this.loadData();
        //  });
    };
    HeaderModel.prototype.XiangXiZK = function (m, e) {
        var div = e.currentTarget.parentNode.parentNode.nextElementSibling;
        var div1 = div.nextElementSibling;
        var div2 = e.currentTarget.lastElementChild;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = 'block';
            div1.style.display = 'block';
            div2.style.transform = "rotate(0deg)";
        }
        else {
            div.style.display = 'none';
            div1.style.display = 'none';
            div2.style.transform = "rotate(180deg)";
        }
    };
    HeaderModel.prototype.zkGengDuo = function (m, e) {
        var div = e.currentTarget.parentNode.nextElementSibling;
        if (!div.style.display || div.style.display == "block") {
            div.style.display = 'none';
        }
        else {
            div.style.display = 'block';
        }
    };
    //选择下拉列表触发的事件
    HeaderModel.prototype.selectOption = function () {
        //this.url = "/api/project/pools";
        this.id = null;
        if (this.projectsource() == null || this.cooperationmode() == null) {
            this.data = {};
            this.data.projectSource = "全部";
            this.data.cooperationMode = "合作方式";
        }
        else {
            this.data = {};
            this.data.projectSource = this.projectsource();
            this.data.cooperationMode = this.cooperationmode();
        }
        if (this.localid() == undefined) {
            this.localid("");
        }
        else {
            this.data.province = this.localid().name;
        }
        if (this.localsomeid() == undefined) {
            this.localsomeid("");
        }
        else {
            this.data.city = this.localsomeid().name;
        }
        this.data.pageIndex = 1;
        return this.loadData().then(function (d) {
        }).catch(function (e) {
        });
    };
    //////////////////////////
    // 关闭项目
    HeaderModel.prototype.close = function (data) {
        var _this = this;
        var flag = confirm("确认关闭这个项目？");
        if (flag) {
            var pageIndex_1 = this.viewModel().data.pageIndex;
            //this.url = "/api/project";
            // this.data.action = "ok";
            // this.id = data.id;
            ajax.put("/api/project/" + data.id, {
                action: "ok",
                userId: authorization.getUserId()
            })
                .then(function (d) {
                // 操作viewmodel
                window.popBox.show(d.message).then(function () {
                    _this.data = {};
                    //this.url = "/api/project/pools";
                    _this.data.projectSource = _this.projectsource();
                    _this.data.cooperationMode = _this.cooperationmode();
                    _this.data.pageIndex = pageIndex_1;
                    _this.id = null;
                    _this.loadData().then(function (d) {
                    }).catch(function (e) {
                    });
                });
            }).catch(function (e) {
            });
        }
    };
    ///////////////////////////搜索项目
    //按条件模糊查询关注人
    HeaderModel.prototype.searchname = function () {
        var _this = this;
        this.choose_index([]);
        if (this.changename().trim() == '') {
        }
        else {
            // this.data.uid = window.localStorage.getItem('UserId');
            ajax.get('/api/user/findnoticer', { name: this.changename() }).then(function (d) {
                _this.postName(d.data);
            });
        }
    };
    //选中
    // 选中某一个业务员
    HeaderModel.prototype.btn_choose = function (res, index, username) {
        var model = this.viewModel();
        if (this.choose_index.indexOf(index) == -1) {
            this.choose_index.push(index);
        }
        else {
            this.choose_index.remove(index);
        }
        if (this.username.indexOf(username) == -1) {
            this.username.push(username);
        }
        else {
            this.username.remove(username);
        }
        return true;
    };
    //全选
    HeaderModel.prototype.btn_choose_all = function (event, index) {
        var vm = this.postName();
        if (event.target.checked) {
            for (var i in vm[index].userdetails) {
                if (this.choose_index.indexOf(vm[index].userdetails[i].id) == -1)
                    this.choose_index.push(vm[index].userdetails[i].id);
            }
        }
        else {
            for (var i in vm[index].userdetails) {
                this.choose_index.remove(vm[index].userdetails[i].id);
            }
        }
        if (event.target.checked) {
            for (var i in vm[index].userdetails) {
                if (this.username.indexOf(vm[index].userdetails[i].userName) == -1)
                    this.username.push(vm[index].userdetails[i].userName);
            }
        }
        else {
            for (var i in vm[index].userdetails) {
                this.username.remove(vm[index].userdetails[i].userName);
            }
        }
        return true;
    };
    //点击确定  保存分配人员 给哪个项目分配人员
    HeaderModel.prototype.sure = function () {
        //点击确定
        //let pageIndex=this.viewModel().data.pageIndex;
        var _this = this;
        if (this.choose_index().length == 0) {
            window.popBox.show("请选择一个业务人员");
            //console.log("没有id");
            return;
        }
        //console.log(this.choose_index().length);
        if (this.choose_index().length > 1) {
            window.popBox.show("只能分配一个业务员");
            return;
        }
        this.popur(0);
        this.data = {};
        //this.url = "/api/project/robbing";id
        //console.log(this.data.pageIndex)
        //this.data.action = "ok";
        //this.id = this.projectId();
        //console.log(this.choose_index()[0]+'----------------分配人id------')
        ajax.put("/api/project/robbing/" + this.projectId(), { action: "ok", ids: this.choose_index()[0], })
            .then(function (d) {
            // 重新加载页面数据
            // 直接操作viewmodel
            //this.projects.remove(this.rowData());
            _this.data = {};
            _this.id = null;
            //this.url = "/api/project/pools";
            _this.data.pageIndex = 1;
            _this.data.projectSource = _this.projectsource();
            _this.data.cooperationMode = _this.cooperationmode();
            return _this.loadData().then(function () {
                window.popBox.show('分配成功');
            });
        });
    };
    //省份二级联动
    HeaderModel.prototype.changelocal = function () {
        var _this = this;
        this.data = {};
        var id;
        if (this.localid() == undefined) {
            id = this.local()[0].id;
        }
        else {
            id = this.localid().id;
        }
        //console.log(id);
        //this.data.pid = id;
        //this.url = '/api/ice/local';
        ajax.get("/api/ice/local", { pid: id })
            .then(function (d) {
            _this.localnext(d.data);
            //数据冲掉
            _this.data = {};
            //this.url = "/api/project/pools";
            _this.data.pageIndex = 1;
            _this.data.projectSource = _this.projectsource();
            _this.data.cooperationMode = _this.cooperationmode();
            if (_this.localid() == undefined) {
                _this.loadData();
            }
            else {
                _this.data.province = _this.localid().name;
                _this.loadData();
            }
        });
    };
    HeaderModel.prototype.changelocalsome = function () {
        //let loc = this.localid().name+','+this.localsomeid().name;
        //this.url = "/api/project/pools";
        this.data = {};
        this.data.pageIndex = 1;
        this.data.projectSource = this.projectsource();
        this.data.cooperationMode = this.cooperationmode();
        if (this.localid() == undefined && this.localsomeid() == undefined) {
            this.loadData();
        }
        else if (this.localid() == undefined && this.localsomeid() != undefined) {
            this.data.city = this.localsomeid().name;
            this.loadData();
        }
        else if (this.localid() != undefined && this.localsomeid() == undefined) {
            this.data.province = this.localid().name;
            this.loadData();
        }
        else {
            this.data.city = this.localsomeid().name;
            this.data.province = this.localid().name;
            this.loadData();
        }
    };
    // 点击抢单
    // 1 获取到当前业务员员的id  2 发送给后台   3 加载数据
    HeaderModel.prototype.qiangDan = function (data) {
        var _this = this;
        var flag = confirm("是否确认抢单?");
        if (flag) {
            this.projects(this.viewModel());
            var pageIndex_2 = this.viewModel().data.pageIndex;
            this.data = {};
            //this.url = "/api/project/robbing";
            this.id = data.id;
            this.data.action = "ok";
            ajax.put("/api/project/robbing/" + data.id, { action: 'ok', ids: authorization.getUserId() })
                .then(function (d) {
                // 直接操作dom 更新数据
                if (d.status == '0') {
                    window.popBox.show('抢单成功');
                    // 操作viewModel
                    _this.projects.remove(data);
                    _this.viewModel(_this.projects());
                    _this.data = {};
                    _this.id = null;
                    //this.url = "/api/project/pools";
                    _this.data.pageIndex = pageIndex_2;
                    _this.data.projectSource = _this.projectsource();
                    _this.data.cooperationMode = _this.cooperationmode();
                    return _this.loadData();
                }
                else {
                    window.popBox.show('抢单失败');
                }
            });
        }
    };
    // 公共的方法
    // loadbubble(){
    // 	return ajax.get('/api/statistics/smessage',{userId:authorization.getUserId(),loginTime:window.localStorage.getItem('0')}).then((d:any)=>{
    // 		ko.postbox.publish('leftMenu_myProject',d.data.count0);
    // 		ko.postbox.publish('leftMenu_myFollowProject',d.data.count1);
    // 		ko.postbox.publish('leftMenu_noFollowNews',d.data.count2);
    // 		ko.postbox.publish('leftMenu_waitProjectNews',d.data.count3);
    // 		ko.postbox.publish('leftMenu_signgedProjectNews',d.data.count4);
    // 		ko.postbox.publish('leftMenu_abandonProjectNews',d.data.count5);
    // 		localStorage.setItem('0',new Date()["Format"]('yyyy-MM-dd hh:mm:ss'))
    // 	})
    // }
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        var _this = this;
        return Promise.all([this.loadnum(), this.loadbubble(), this.loadData().then(function (d) {
                _this.projects(_this.viewModel());
            }).then(function (d) {
                //this.hm.data = {};
                //this.hm.url = '/api/ice/local';
                //this.hm.data.pid = 1;// 这个是随便来的
                ajax.get('/api/ice/local', { pid: 1 })
                    .then(function (d) {
                    _this.local(d.data);
                    //this.hm.data = {};
                    // this.hm.url = '/api/ice/local';
                    // this.hm.data.pid = d.data[0].id;
                    ajax.get("/api/ice/local", { pid: d.data[0].id })
                        .then(function (d) {
                        _this.localnext(d.data);
                        _this.viewModel(_this.projects());
                    });
                });
            })
                .catch(function (e) {
                //console.log("首次加载页面出现异常");
            })]).then(function () { });
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container.querySelector('.Myproject'));
        //this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        var _this = this;
        // 获取到该用户的角色
        this.hm.projectsource('全部');
        ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "信息池" });
        ajax.get("/api/user/isadmin", { uid: window.localStorage.getItem("UserId") })
            .then(function (d) {
            _this.hm.isAdmin(d.data);
        });
        ajax.get("/api/user/buttoninfo", { id: window.localStorage.getItem("UserId") })
            .then(function (d) {
            //console.log(d.data);
            _this.hm.guanbi(d.data.guanbi);
            _this.hm.fenpei(d.data.fenpei);
            _this.hm.qiangdan(d.data.qiangdan);
        });
        ajax.get("/api/menu/infomationPool", { uid: window.localStorage.getItem("UserId") });
        /////
        this.hm.options([{ id: 0, text: '全部' }, { id: 1, text: '微信公众号' }, { id: 2, text: 'PC端' }, { id: 3, text: '移动端' }]);
        // console.log(window.localStorage.getItem("UserId"));
        this.hm.userId.push(window.localStorage.getItem("UserId"));
        this.hm.id = null;
        this.hm.cooperation([{ typeId: 4, typeName: '合作方式', typeData: '合作方式' }]);
        //this.hm.url = "/api/project/pools";
        ajax.get("/api/project/type").then(function (d) {
            _this.hm.cooperation(d.data.reverse());
            // for (let i = 0; i < d.data.length; i++) {
            // 	this.hm.cooperation.push(d.data[i]);
            // }
        });
        this.hm.data = {};
        this.hm.data.pageIndex = 1;
        this.hm.data.projectSource = '全部';
        this.hm.data.cooperationMode = "合作方式";
        return this.hm.load();
    };
    return mModel;
}(Page));
export default mModel;
